import { Switch } from 'antd';
import LinkButton from 'components/shared/button/LinkButton';
import { Spinner } from 'components/shared/loader/Spinner';
import {
  ACCESS_VIEWS,
  ACCOUNT_TYPE,
  areas,
  CHART_VIEWS,
  CV_VIEW_NAME,
  FLAG,
  HTTP_UNPROCESSABLE_ENTITY,
  INSIGHT_TYPE,
  MODULE_NAME,
  NOT_AVAILABLE,
  NULL_STRING,
  NUMBER_ZERO,
  OS_FLAG,
  PATHWAY_URL,
  PAYMENT_METHOD,
  PRIORITY_ADD_SUCCESS_MSG,
  QUERY_KEY,
  SUPERGROUP_GPO_INDICATOR,
  TRUE,
  OVERLAY_TRIGGER,
} from 'constants/constants';
import { useEffect, useRef, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Carousel, Col, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  getCustomerExpr,
  getCustomerExprWithRole,
  isArray,
  isKeysAreNull,
  roundToOne,
} from 'utils/utils';
import classes from './Banner.module.scss';
import Contacts from './Contacts';
import PieChartSection from './pie-chart-section/PieChartSection';

import {
  getBeamData,
  getVOCResultApi,
  getCustomerContacts,
  getGpoSuperGroup,
  getPathwayData,
  getPayerPieData,
} from 'store/customer/customer-view-actions';

import {
  setActiveSectionTab,
  setAllInsightView,
  setBeamChart,
  setBeamChartSite,
  setChartType,
  setCrmPercent,
  setCRMScores,
  setFilterInit,
  setFocusAccountDisabled,
  setInsightType,
  setPaymentMethod,
  setPriorityCustomers,
  setSelectedCustomer,
  setSelectedInsightView,
  setSeletedView,
  setSurveyTotal,
  setVocAlertFlag,
} from 'store/customer/customerViewSlice';

import { CRM_EXPRESSIONS, REPLACE_STRING, USES } from 'constants/constants';

import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import Popover from 'react-bootstrap/Popover';
import { Link, useNavigate } from 'react-router-dom';
import {
  addMemberToTeam,
  deleteAccount,
} from 'services/configure-priority.service';
import { setFocusAccountChecked } from 'store/customer/customerViewSlice';
import { setCards, setDefaultCard } from 'store/home/homeMyViewSlice';
import { getArrayToStringArray } from 'utils/utils';
import StakeholderAlerts from './StakeholderAlerts';
import { useQuery } from '@tanstack/react-query';
import { useCustomerDetails } from './Banner.hooks';
import { useTouchDevice } from 'hooks/useTouchDevice';

const Banner = (props) => {
  const view = props.data;
  const dispatch = useDispatch();

  const priorityCustomers = useSelector(
    (state) => state?.CustomerView?.priorityCustomers
  );
  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const beamChart = useSelector((state) => state?.CustomerView?.beamChart);
  const beamChartSite = useSelector(
    (state) => state?.CustomerView?.beamChartSite
  );

  const [beamQuarter, setBeamQuarter] = useState('');
  const [beamChartSiteQuarter, setBeamChartSiteQuarter] = useState('');
  const [crmQuarter, setCrmQuarter] = useState('');
  const crmScores = useSelector((state) => state?.CustomerView?.crmScores);
  const crmPercent = useSelector((state) => state?.CustomerView?.crmPercent);
  const surveys = useSelector((state) => state?.CustomerView?.surveyTotal);
  const timespans = useSelector((state) => state?.CustomerView?.timespans);
  const alertFlag = useSelector(
    (state) => state?.CustomerView?.vocAlertFlag === TRUE
  );
  const paymentMethod = useSelector(
    (state) => state?.CustomerView?.paymentMethod
  );

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const contacts = useSelector((state) => state?.CustomerView?.contacts);

  const [payerPieData, setPayerPieData] = useState([]);
  const [payerPieDate, setPayerPieDate] = useState(NULL_STRING);
  const [show, setShow] = useState(false);

  const showSiteChart = beamChartSite?.contractSegment?.length > 0;

  const showPayerChart = payerPieData?.length > 0;
  const [selectChartView, setSelectedChartView] = useState(
    CHART_VIEWS.CONTRACT
  );
  const [veevaUrl, setVeevaUrl] = useState('');
  const firstloadRef = useRef(true);
  const showChart =
    selectChartView === CHART_VIEWS.CONTRACT
      ? beamChart?.contractSegment?.length > 0
      : showPayerChart;
  const [loading, setLoading] = useState(false);

  const focussedAccount = useSelector(
    (state) => state?.CustomerView?.focusAccountChecked
  );

  const [checkedSwitch, setCheckedSwitch] = useState(focussedAccount);
  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );
  const navigation = useNavigate();

  const userRestrictedEcosystemt = useSelector(
    (state) => state?.Auth?.userRestrictedEcosystemt
  );

  const isTouchDevice = useTouchDevice();

  const id340BValue =
    selectedView === ACCOUNT_TYPE.account
      ? beamChart?.id340B
      : beamChartSite?.id340B;
  const [showStakeholderAlerts, setShowStakeholderAlerts] = useState(false);

  const onToggleChange = async (checked) => {
    setLoading(true);
    try {
      if (checked) {
        // HCO : If there are restricted ecosystem for user then checked with customer ecosystem from backend to set priority customer
        let ecosystems =
          userRestrictedEcosystemt?.length > 0
            ? getArrayToStringArray(userRestrictedEcosystemt)
            : undefined;

        const payload = {
          unixId: unixId,
          customerId: selectedCustomer?.value,
          primaryFlag: 'N',
          squad: null,
          roleId,
          ecosystems,
        };

        const response = await addMemberToTeam(payload);

        if (response?.error?.code === HTTP_UNPROCESSABLE_ENTITY) {
          toast.error(`${response?.message}`);
          setCheckedSwitch(false);
        } else if (response.result) {
          dispatch(setCards([]));
          dispatch(setDefaultCard([]));
          dispatch(
            setPriorityCustomers([...priorityCustomers, selectedCustomer])
          );
          dispatch(getCustomerContacts(selectedCustomer?.value));
          setCheckedSwitch(true);
          dispatch(setFocusAccountChecked(true));
          dispatch(setFocusAccountDisabled(false));

          toast.success(
            `${selectedCustomer?.label} ${PRIORITY_ADD_SUCCESS_MSG}`
          );
        }
      } else {
        const response = await deleteAccount(
          selectedCustomer?.value,
          unixId,
          roleId
        );
        if (response.error) {
          throw new Error(response.error);
        }
        dispatch(setCards([]));
        dispatch(setDefaultCard([]));
        dispatch(getCustomerContacts(selectedCustomer?.value));
        setCheckedSwitch(false);
        dispatch(setFocusAccountChecked(false));
        const filterpriorityCustomers = priorityCustomers.filter(
          (focusAccount) => focusAccount.value !== selectedCustomer?.value
        );
        dispatch(setPriorityCustomers(filterpriorityCustomers));
        dispatch(
          setFocusAccountDisabled(!(filterpriorityCustomers.length > 0))
        );
        toast.success(
          `${selectedCustomer?.label}  has been successfully removed as your priority  ${selectedView}.`
        );
      }
    } catch (error) {
      toast.error('Operation failed.');
      setCheckedSwitch(!checked);
    } finally {
      setLoading(false);
    }
  };

  const getUserView = () => {
    if (componentAccessList?.length === 0) {
      return ACCESS_VIEWS.NONE;
    }
    if (view === ACCOUNT_TYPE.site) {
      if (
        componentAccessList?.includes('Banner-Contract-Pie') &&
        componentAccessList?.includes('Payer-Mix-Pie')
      ) {
        return ACCESS_VIEWS.ALL;
      } else if (
        componentAccessList?.includes('Payer-Mix-Pie') &&
        !componentAccessList?.includes('Banner-Contract-Pie')
      ) {
        setSelectedChartView(CHART_VIEWS.PAYER);
        return ACCESS_VIEWS.PAYER;
      } else if (
        componentAccessList?.includes('Banner-Contract-Pie') &&
        !componentAccessList?.includes('Payer-Mix-Pie')
      ) {
        return ACCESS_VIEWS.CONTRACT;
      }
    } else if (view === ACCOUNT_TYPE.account) {
      if (
        componentAccessList?.includes('Banner-Contract-Pie') &&
        componentAccessList?.includes('Payer-Mix-Pie')
      ) {
        return ACCESS_VIEWS.ALL;
      } else if (
        componentAccessList?.includes('Payer-Mix-Pie') &&
        !componentAccessList?.includes('Banner-Contract-Pie')
      ) {
        setSelectedChartView(CHART_VIEWS.PAYER);
        return ACCESS_VIEWS.PAYER;
      } else if (
        componentAccessList?.includes('Banner-Contract-Pie') &&
        !componentAccessList?.includes('Payer-Mix-Pie')
      ) {
        return ACCESS_VIEWS.CONTRACT;
      }
    }
  };
  // eslint-disable-next-line
  const [accessView, setAccessView] = useState(ACCESS_VIEWS.NONE);

  useEffect(() => {
    setAccessView(getUserView());
  }, []);

  // fetch payer mix data using react query
  const { data: payerPie } = useQuery({
    queryKey: [
      QUERY_KEY.PayerPieHCOData,
      selectedCustomer?.value,
      selectChartView,
    ],
    queryFn: async () => {
      // fetch the data from qlik for payer mix
      return await getPayerPieData(
        selectedCustomer?.value,
        selectedCustomer?.flag,
        roleId,
        CV_VIEW_NAME.HCO
      );
    },
    // only run the query if we have a selected customer
    enabled:
      (accessView === ACCESS_VIEWS.PAYER ||
        (accessView === ACCESS_VIEWS.ALL &&
          selectChartView === CHART_VIEWS.PAYER)) &&
      selectedCustomer?.value
        ? true
        : false,
  });

  // set payer mix data to state
  useEffect(() => {
    if (payerPie) {
      setPayerPieDate(payerPie?.timeframe);
      setPayerPieData(payerPie?.values);
    }
  }, [payerPie]);

  useEffect(() => {
    setBeamQuarter(
      timespans
        ?.filter((item) => item.Module === MODULE_NAME.ContractSegment)
        [NUMBER_ZERO]?.Value?.replaceAll("'", ' ')
    );
    setBeamChartSiteQuarter(
      timespans
        ?.filter((item) => item.Module === MODULE_NAME.ContractSegment)
        [NUMBER_ZERO]?.Value?.replaceAll("'", ' ')
    );
    setCrmQuarter(
      timespans
        ?.filter((item) => item.Module === MODULE_NAME.BannerCRM)
        [NUMBER_ZERO]?.Value?.replaceAll("'", ' ')
    );
  }, [timespans]);

  const onsegmentChange = (e) => {
    setSelectedChartView(e);
  };

  // Legend with info icon and tooltip for contract segment (e.g., 340B membership)
  const contractMembership =
    view === ACCOUNT_TYPE.site
      ? beamChartSite?.membership
      : beamChart?.membership;
  const contract =
    view === ACCOUNT_TYPE.site
      ? beamChartSite.contractSegment
      : beamChart.contractSegment;

  const hasContacts = contacts?.length > 0;

  // when the user selects an account in the dropdown
  // we check of the there is a value
  // then we get all the data we need to display on the page
  useEffect(() => {
    if (!Array.isArray(selectedCustomer)) {
      setVeevaUrl(
        `${process.env.REACT_APP_VEEVA_APP_URL}${selectedCustomer?.veevaId}/view`
      );
      fetchData();
    }
  }, [selectedCustomer?.value]);

  useEffect(() => {
    const checkPriority =
      contacts?.length > 0
        ? contacts?.some(
            (item) => item?.unixId === unixId && item.roleCode === roleId
          )
        : false;

    setCheckedSwitch(checkPriority);
    dispatch(setFocusAccountChecked(checkPriority));
  }, [contacts]);

  useEffect(() => {
    firstloadRef.current = true;
  }, [selectedView]);

  // fetch affiliated to data using react query
  const { data: customerDetails, isLoading: isCustomerLoading } =
    useCustomerDetails(selectedCustomer);

  // fetch pathway uses data using react query
  const { data: pathwayUses } = useQuery({
    queryKey: [QUERY_KEY.PathwayUsesData, selectedCustomer?.value],
    queryFn: async () => {
      let result = await getPathwayData(selectedCustomer?.value, USES.appId);
      return result?.parentOrg || null;
    },
    // fetch if account view and not os affiliated
    enabled:
      view === ACCOUNT_TYPE.account &&
      selectedCustomer?.flag !== OS_FLAG &&
      selectedCustomer?.value
        ? true
        : false,
  });

  // Fetch CRM KPI data and crm quater using react query
  const { data: crmResult } = useQuery({
    queryKey: [QUERY_KEY.CrmKpiData, selectedCustomer?.value],
    queryFn: async () => {
      // fetch CRM KPI data
      let result = await getCRMResult(selectedCustomer?.value, roleId, view);
      return result;
    },
    // only run the query if we have a selected customer
    enabled: !!selectedCustomer?.value,
  });

  // set CRM KPI data to store like crm scores, percent, servays total, payment method and voc alert flag
  useEffect(() => {
    if (crmResult) {
      dispatch(
        setCRMScores({
          nps: crmResult.npsScore,
          sat: crmResult.satScore,
          partner: crmResult.partnerScore,
        })
      );
      dispatch(
        setCrmPercent({
          nps: crmResult.npsPercent,
          sat: crmResult.satPercent,
          partner: crmResult.partnerPercent,
        })
      );
      dispatch(
        setSurveyTotal({
          nps: crmResult.npsSurveyCount,
          sat: crmResult.satSurveyCount,
          partner: crmResult.partnerSurveyCount,
        })
      );
      dispatch(setPaymentMethod(crmResult.paymentMethod));
      dispatch(setVocAlertFlag(crmResult.vocAlertFlag));
    }
  }, [crmResult]);

  // Fetch BEAM data and beam quarter using react query
  const { data: beamChartData } = useQuery({
    queryKey: [QUERY_KEY.BeamChartData, selectedCustomer?.value],
    queryFn: async () => {
      // fetch BEAM data for account or site view
      return await getBeamData(selectedCustomer?.value, view);
    },
    // only run the query if we have a selected customer
    enabled:
      (accessView === ACCESS_VIEWS.CONTRACT ||
        (accessView === ACCESS_VIEWS.ALL &&
          selectChartView === CHART_VIEWS.CONTRACT)) &&
      selectedCustomer?.value
        ? true
        : false,
  });

  // set BEAM data to store for account or site view
  useEffect(() => {
    if (beamChartData) {
      if (view === ACCOUNT_TYPE.site) {
        dispatch(setBeamChartSite(beamChartData));
      } else {
        dispatch(setBeamChart(beamChartData));
      }
    }
  }, [beamChartData]);

  // fetch onc gpo super group data using react query
  const { data: oncGpoSuperGroup } = useQuery({
    queryKey: [QUERY_KEY.OncGpoSuperGroupsData, selectedCustomer?.value],
    queryFn: async () => {
      return await getGpoSuperGroup(selectedCustomer?.value);
    },
    enabled:
      selectedCustomer?.value && view === ACCOUNT_TYPE.site ? true : false,
  });

  const fetchData = async () => {
    resetStoreValues();
    dispatch(getCustomerContacts(selectedCustomer?.value));
  };

  const getCRMResult = async (customerId, roleId, view) => {
    // fetch CRM scores, percent, servays total, payment method and voc alert flag
    return await getVOCResultApi(customerId, roleId, view);
  };

  const handleclick = (affiliatedTo) => {
    dispatch(setActiveSectionTab(''));
    if (affiliatedTo) {
      const payload = {
        value: affiliatedTo?.mdmId,
        label: affiliatedTo?.name,
        flag: FLAG.account,
      };
      dispatch(setFilterInit());
      dispatch(setSeletedView('account'));
      dispatch(setSelectedCustomer(payload));
      dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
      dispatch(setSelectedInsightView({}));
      dispatch(setAllInsightView([]));
      navigation(`/customerView/list/${affiliatedTo?.name}`);
    }
  };

  // reset the store values
  const resetStoreValues = () => {
    dispatch(setCRMScores({}));
    dispatch(setBeamChart({}));
    dispatch(setBeamChartSite({}));
  };

  const handleClickWarning = () => {
    setShowStakeholderAlerts(true);
  };

  return (
    <Carousel>
      <Carousel.Item>
        {/* banner */}
        <section
          className={`${classes['banner-wrapper']} animate__animated animate__fadeIn animate__slower`}>
          <Row>
            <Col
              xs={12}
              md={8}
              xl={9}
              className={`${classes['banner-left-container']}`}>
              {/* title */}
              <Row>
                <Col className='ps-0'>
                  <Fade>
                    <p className='title__bold title__x-large title__capitalize mb-0'>
                      {selectedCustomer?.label?.length > 50 ? (
                        <OverlayTrigger
                          overlay={
                            <Popover className='p-2'>
                              {selectedCustomer?.label}
                            </Popover>
                          }>
                          <p className='title__bold title__x-large title__capitalize mb-0'>
                            {selectedCustomer?.label?.length > 50
                              ? `${selectedCustomer?.label
                                  ?.toLowerCase()
                                  .substring(0, 50)}...`
                              : selectedCustomer?.label?.toLowerCase()}
                            <i className='icon icon__veeva'></i>
                          </p>
                        </OverlayTrigger>
                      ) : (
                        <>
                          {selectedCustomer?.label?.toLowerCase()}
                          {selectedCustomer?.label && (
                            <a
                              href={veevaUrl}
                              target='_blank'
                              rel='noreferrer'>
                              <i className='icon icon__veeva'></i>
                            </a>
                          )}
                        </>
                      )}
                    </p>

                    {!selectedCustomer?.label && (
                      <span className='title__x-large'>{NULL_STRING}</span>
                    )}

                    <p className='text text__capitalize'>
                      {customerDetails?.classification?.toLowerCase()}
                      {componentAccessList?.includes(PAYMENT_METHOD) && (
                        <OverlayTrigger
                          overlay={
                            <Popover
                              className={`${classes['banner_poper']} text text__x-small`}>
                              <div className='text text__x-small pe-2 ps-2 pt-1 pb-1'>
                                <span className='text text__bold'>
                                  Contract Payment Method:{' '}
                                </span>
                                <span className='text text__x-small'>
                                  {paymentMethod
                                    ? paymentMethod
                                    : NOT_AVAILABLE}
                                </span>
                              </div>
                            </Popover>
                          }>
                          <i className='icon icon__paymentCheck ms-2'></i>
                        </OverlayTrigger>
                      )}
                      {view === ACCOUNT_TYPE.site &&
                        componentAccessList?.includes(
                          SUPERGROUP_GPO_INDICATOR
                        ) && (
                          <OverlayTrigger
                            overlay={
                              <Popover
                                className={`${classes['banner_poper']} text text__x-small`}>
                                <div>
                                  <div className='text text__x-small pe-2 ps-2 pt-1 '>
                                    <span className='text text__bold'>
                                      Oncology Supergroup:{' '}
                                    </span>
                                    <span className='text text__x-small'>
                                      {oncGpoSuperGroup?.superGpo &&
                                      oncGpoSuperGroup?.superGpo !== ''
                                        ? oncGpoSuperGroup?.superGpo
                                        : NOT_AVAILABLE}
                                    </span>
                                  </div>
                                  <div className='text text__x-small pe-2 ps-2 pb-1'>
                                    <span className='text text__bold'>
                                      Oncology GPO:{' '}
                                    </span>
                                    <span className='text text__x-small'>
                                      {oncGpoSuperGroup?.gpoType &&
                                      oncGpoSuperGroup?.gpoType !== ''
                                        ? oncGpoSuperGroup?.gpoType
                                        : NOT_AVAILABLE}
                                    </span>
                                  </div>
                                </div>
                              </Popover>
                            }>
                            <i className='icon icon__supergroupIndicator ms-2'></i>
                          </OverlayTrigger>
                        )}
                    </p>

                    {!customerDetails?.classification && (
                      <span>{NULL_STRING}</span>
                    )}
                  </Fade>
                </Col>
              </Row>

              {/* address and relation */}
              <Row>
                {/* account info */}
                <Col
                  className='d-flex p-0'
                  md={5}>
                  {/* address */}
                  <div className={classes['info-section']}>
                    <Fade cascade>
                      <p className='title__bold'>Address</p>
                      {isCustomerLoading ? (
                        <Spinner area={areas.bannerSegment} />
                      ) : (
                        <div>
                          {!isKeysAreNull(customerDetails, [
                            'address1',
                            'state',
                            'city',
                            'zip',
                          ]) ? (
                            <p className='title__x-small'>
                              {customerDetails?.address1} <br />
                              {customerDetails?.city}
                              {customerDetails?.state || customerDetails?.zip
                                ? ', '
                                : ' '}
                              {customerDetails?.state} {customerDetails?.zip}
                            </p>
                          ) : (
                            <span className='text text__x-small'>
                              {NOT_AVAILABLE}
                            </span>
                          )}
                        </div>
                      )}
                    </Fade>
                  </div>

                  {/* uses */}
                  <div className={classes['info-section']}>
                    {view === ACCOUNT_TYPE.account &&
                    selectedCustomer?.flag !== OS_FLAG ? (
                      <Fade>
                        <p className='title__bold'>Pathway</p>
                        {pathwayUses && (
                          <p className='mb-0'>
                            <Link
                              to={PATHWAY_URL}
                              target='_blank'
                              className='text-white'>
                              {pathwayUses}{' '}
                              <i className='icon icon__external d-inline-block ms-1'></i>
                            </Link>
                          </p>
                        )}

                        {!pathwayUses && <span>{NULL_STRING}</span>}
                      </Fade>
                    ) : (
                      <Fade>
                        <p className='title__bold'>Affiliated To</p>
                        {customerDetails?.affilatedTo?.name &&
                          !isCustomerLoading && (
                            <span
                              className={`${classes['affaliated-to']} span-link affiliated-link`}
                              onClick={() =>
                                handleclick(customerDetails?.affilatedTo)
                              }>
                              {customerDetails?.affilatedTo?.name}
                            </span>
                          )}

                        {!customerDetails?.affilatedTo?.name && (
                          <span>{NULL_STRING}</span>
                        )}
                      </Fade>
                    )}
                  </div>
                </Col>

                {/* relationship */}
                <Col
                  className={`${classes['info-container']} justify-content-start p-0`}
                  style={{ marginTop: '-30px' }}
                  md={7}>
                  <div
                    className={`${alertFlag ? classes['alert_box'] : ''} d-flex col-md-8`}>
                    {/* nps score */}
                    {alertFlag && (
                      <div className='d-flex align-items-center'>
                        <OverlayTrigger
                          trigger={isTouchDevice ? [] : OVERLAY_TRIGGER}
                          overlay={
                            <Popover className='p-2'>
                              Please click here for detailed information.
                            </Popover>
                          }>
                          <i
                            onClick={() => handleClickWarning()}
                            className={`icon icon__warning_alert_clickable`}
                          />
                        </OverlayTrigger>
                      </div>
                    )}
                    <div className={classes['info-section']}>
                      <Fade cascade>
                        <p
                          className={`${classes['figures']} title__bold d-inline-block`}>
                          <OverlayTrigger
                            overlay={
                              crmPercent?.nps > 0 ? (
                                <Popover className='p-2'>
                                  The current rolling 12 months VoC score is
                                  higher than that of the previous rolling 12
                                  months.
                                </Popover>
                              ) : crmPercent?.nps < 0 ? (
                                <Popover className='p-2'>
                                  The current rolling 12 months VoC score is
                                  lower than that of the previous rolling 12
                                  months.
                                </Popover>
                              ) : (
                                ''
                              )
                            }>
                            <i
                              className={`icon icon__arrow-${
                                crmPercent?.nps > 0
                                  ? 'up'
                                  : crmPercent?.nps < 0
                                    ? 'down'
                                    : ''
                              } me-1`}></i>
                          </OverlayTrigger>
                          <span className='title__bold title__medium'>
                            {roundToOne(crmScores?.nps)}
                          </span>
                        </p>
                        <OverlayTrigger
                          overlay={
                            <Popover className='p-2'>
                              Difference between % Promoters (rating 9-10) and %
                              Detractors (rating 0-6). An NPS of 60 is
                              considered excellent, while a score of 80 or
                              higher is considered world-class. Only applies to
                              relationship surveys.
                            </Popover>
                          }>
                          <p className='title title__bold'>
                            Relationship <br />
                            NPS
                          </p>
                        </OverlayTrigger>
                        <p>
                          {crmQuarter}{' '}
                          {surveys?.nps ? (
                            <OverlayTrigger
                              overlay={
                                <Popover className='p-2'>
                                  Number of surveys within the rolling 12
                                  months.
                                </Popover>
                              }>
                              <span>{'(#' + surveys?.nps + ')'}</span>
                            </OverlayTrigger>
                          ) : (
                            ''
                          )}
                        </p>
                      </Fade>
                      {!crmQuarter && !surveys?.nps && (
                        <Fade>
                          <span>{NULL_STRING}</span>
                          <Spinner
                            area={areas.bannerNPS}
                            css='inline'
                          />
                        </Fade>
                      )}
                    </div>
                    {/* trusted partner score */}
                    <div className={classes['info-section']}>
                      <Fade cascade>
                        <p
                          className={`${classes['figures']} title__bold d-inline-block`}>
                          <OverlayTrigger
                            overlay={
                              crmPercent?.partner > 0 ? (
                                <Popover className='p-2'>
                                  The current rolling 12 months VoC score is
                                  higher than that of the previous rolling 12
                                  months.
                                </Popover>
                              ) : crmPercent?.partner < 0 ? (
                                <Popover className='p-2'>
                                  The current rolling 12 months VoC score is
                                  lower than that of the previous rolling 12
                                  months.
                                </Popover>
                              ) : (
                                ''
                              )
                            }>
                            <i
                              className={`icon icon__arrow-${
                                crmPercent?.partner > 0
                                  ? 'up'
                                  : crmPercent?.partner < 0
                                    ? 'down'
                                    : ''
                              } me-1`}></i>
                          </OverlayTrigger>
                          <span className='title__bold title__medium'>
                            {roundToOne(crmScores?.partner)}
                          </span>
                          {/* <LinkButton
                            className='ms-2'
                            onClick={() =>
                              relationshipNpsClickHandler('partner')
                            }>
                            <i className='icon icon__external'></i>
                          </LinkButton>
                          <DataModal
                            component='RelationshipChart'
                            show={dataModal}
                            onHide={closeRelationshipNps}
                            data={lineChart}
                          /> */}
                        </p>
                        <OverlayTrigger
                          overlay={
                            <Popover className='p-2'>
                              % of users whose responses are in Top 2 boxes
                              (ratings 9-10) . A score of 80 or higher is
                              considered excellent. Only applies to relationship
                              surveys.
                            </Popover>
                          }>
                          <p className='title title__bold animate__animated animate__fadeIn'>
                            Relationship <br />
                            Trusted Partner
                          </p>
                        </OverlayTrigger>
                        <p className='title title__small animate__animated animate__fadeIn'>
                          {crmQuarter}{' '}
                          {surveys?.partner ? (
                            <OverlayTrigger
                              overlay={
                                <Popover className='p-2'>
                                  Number of surveys within the rolling 12
                                  months.
                                </Popover>
                              }>
                              <span>{'(#' + surveys?.partner + ')'}</span>
                            </OverlayTrigger>
                          ) : (
                            ''
                          )}
                        </p>
                      </Fade>

                      {!crmQuarter && !surveys?.partner && (
                        <Fade>
                          <span>{NULL_STRING}</span>
                          <Spinner
                            area={areas.bannerNPS}
                            css='inline'
                          />
                        </Fade>
                      )}
                    </div>
                  </div>
                  {/* sat score */}
                  <div
                    className={`${classes['info-section']} ${alertFlag ? 'pt-3' : ''} col-md-8`}>
                    <Fade cascade>
                      <p
                        className={`${classes['figures']} title__bold d-inline-block`}>
                        <OverlayTrigger
                          overlay={
                            crmPercent?.sat > 0 ? (
                              <Popover className='p-2'>
                                The current rolling 12 months VoC score is
                                higher than that of the previous rolling 12
                                months.
                              </Popover>
                            ) : crmPercent?.sat < 0 ? (
                              <Popover className='p-2'>
                                The current rolling 12 months VoC score is lower
                                than that of the previous rolling 12 months.
                              </Popover>
                            ) : (
                              ''
                            )
                          }>
                          <i
                            className={`icon icon__arrow-${
                              crmPercent?.sat > 0
                                ? 'up'
                                : crmPercent?.sat < 0
                                  ? 'down'
                                  : ''
                            } me-1`}></i>
                        </OverlayTrigger>
                        <span className='title__bold title__medium'>
                          {roundToOne(crmScores?.sat)}
                        </span>
                        {/* <LinkButton
                          className='ms-2'
                          onClick={() => relationshipNpsClickHandler('sat')}>
                          <i className='icon icon__external'></i>
                        </LinkButton>
                        <DataModal
                          component='RelationshipChart'
                          show={dataModal}
                          onHide={closeRelationshipNps}
                          data={lineChart}
                        /> */}
                      </p>
                      <OverlayTrigger
                        overlay={
                          <Popover className='p-2'>
                            % of users whose responses are in Top 2 boxes
                            (ratings 9-10) . A score of 80 or higher is
                            considered excellent. Only applies to post
                            interaction surveys.
                          </Popover>
                        }>
                        <p className='title title__bold animate__animated animate__fadeIn'>
                          Post Interaction <br />
                          Overall Sat
                        </p>
                      </OverlayTrigger>
                      <p className='title title__small animate__animated animate__fadeIn'>
                        {crmQuarter}{' '}
                        {surveys?.sat ? '(#' + surveys?.sat + ')' : ''}
                      </p>
                    </Fade>
                    {!crmQuarter && !surveys?.sat && (
                      <Fade>
                        <span>{NULL_STRING}</span>
                        <Spinner
                          area={areas.bannerNPS}
                          css='inline'
                        />
                      </Fade>
                    )}
                  </div>
                </Col>
              </Row>

              {/* contacts */}
              <Row className='mt-2'>
                <Fade className='ps-0'>
                  <div className='d-flex align-items-center mb-3'>
                    <p className='title__bold me-4 mb-0 animate__animated animate__fadeIn'>
                      Genentech Point of Contact
                    </p>

                    {hasContacts && (
                      <LinkButton
                        className={classes['link-cta']}
                        onClick={() => setShow(true)}>
                        <i className='icon icon__external'></i>
                        View All
                      </LinkButton>
                    )}
                    <Switch
                      key={checkedSwitch}
                      className='ms-3'
                      checkedChildren={
                        <i
                          className={`m-0 icon icon__white_primarycontact`}></i>
                      }
                      checked={checkedSwitch}
                      defaultChecked={focussedAccount}
                      onChange={onToggleChange}
                      size='small'
                      loading={loading}
                    />
                    <OverlayTrigger
                      overlay={
                        <Popover className='p-2'>
                          Setting a customer as a priority designates you as a
                          Point of Contact (POC) for the customer, fostering
                          collaboration with the account team.
                        </Popover>
                      }>
                      <span
                        className={`ms-2 text text__x-small text-decoration-underline`}>
                        Set as Priority
                      </span>
                    </OverlayTrigger>
                  </div>
                </Fade>
                <Fade className='ps-0'>
                  <Contacts
                    contacts={contacts}
                    splitIndex={3}
                    switch={checkedSwitch}
                  />
                </Fade>
              </Row>
            </Col>

            {/* contract segment */}
            <Col
              xs={12}
              md={4}
              xl={3}
              className={`${classes['banner-right-container']} position-relative animate__animated animate__fadeIn`}>
              <PieChartSection
                accessView={accessView}
                view={view}
                selectChartView={selectChartView}
                payerPieDate={payerPieDate}
                showPayerChart={showPayerChart}
                payerPieData={payerPieData}
                beamChartSiteQuarter={beamChartSiteQuarter}
                beamQuarter={beamQuarter}
                showSiteChart={showSiteChart}
                showChart={showChart}
                beamChartSite={beamChartSite}
                beamChart={beamChart}
                id340BValue={id340BValue}
                contract={contract}
                contractMembership={contractMembership}
                onsegmentChange={onsegmentChange}
              />
            </Col>
          </Row>
        </section>

        {/* contact modal */}
        <Modal
          size='lg'
          className='title gne-modal contact'
          show={show}
          onHide={() => setShow(false)}>
          <Modal.Header
            className={`me-3`}
            closeButton>
            <Modal.Title>
              <p className='title__bold title__base animate__animated animate__fadeIn'>
                <i className='icon icon__user'></i>
                Genentech Point of Contact
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='overflow-y-auto'>
            <Contacts contacts={contacts} />
          </Modal.Body>
        </Modal>
        {/* Stakeholders Engagement Alerts modal */}
        <Modal
          size='xl'
          className='title gne-modal'
          show={showStakeholderAlerts}
          onHide={() => setShowStakeholderAlerts(false)}>
          <Modal.Header
            className={`me-3`}
            closeButton>
            <Modal.Title>
              <p className='title__bold title__base animate__animated animate__fadeIn'>
                <i className='icon icon__warning_black me-2'></i>
                VoC Stakeholder Engagement Alerts
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='overflow-y-auto'>
            <StakeholderAlerts
              onClose={() => setShowStakeholderAlerts(false)}
            />
          </Modal.Body>
        </Modal>
      </Carousel.Item>
    </Carousel>
  );
};

export default Banner;
